export const useLogo = () => {
  const { apiClient } = useShopwareContext();
  
  const { data: logoData } = useAsyncData('logo', async () => {
    try {
      const logoResponse = await (apiClient.invoke as any)(
        "getLogo get /get-logo",
        { pathParams: {} }
      );

      if (logoResponse && logoResponse?.data) {
        return logoResponse?.data?.data?.logo;
      }
    } catch (error) {
      console.error('Failed to load logo:', error);
    }
    return null;
  });

  return {
    logoData
  };
};
